/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as SchedulesRouteImport } from './routes/schedules'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as EditRouteImport } from './routes/edit'
import { Route as IndexRouteImport } from './routes/index'
import { Route as RunsIndexRouteImport } from './routes/runs/index'
import { Route as PersonasIndexRouteImport } from './routes/personas/index'
import { Route as PerformanceIndexRouteImport } from './routes/performance/index'
import { Route as ContentIndexRouteImport } from './routes/content/index'
import { Route as TriggersPersonaRouteImport } from './routes/triggers/persona'
import { Route as TriggersContentRouteImport } from './routes/triggers/content'
import { Route as RunsWorkflowIdRouteImport } from './routes/runs/$workflowId'
import { Route as PersonasPersonaIdRouteImport } from './routes/personas/$personaId'
import { Route as PerformanceContentIdRouteImport } from './routes/performance/$contentId'
import { Route as ContentContentIdRouteImport } from './routes/content/$contentId'

const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const SchedulesRoute = SchedulesRouteImport.update({
  id: '/schedules',
  path: '/schedules',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const EditRoute = EditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const RunsIndexRoute = RunsIndexRouteImport.update({
  id: '/runs/',
  path: '/runs/',
  getParentRoute: () => rootRouteImport,
} as any)
const PersonasIndexRoute = PersonasIndexRouteImport.update({
  id: '/personas/',
  path: '/personas/',
  getParentRoute: () => rootRouteImport,
} as any)
const PerformanceIndexRoute = PerformanceIndexRouteImport.update({
  id: '/performance/',
  path: '/performance/',
  getParentRoute: () => rootRouteImport,
} as any)
const ContentIndexRoute = ContentIndexRouteImport.update({
  id: '/content/',
  path: '/content/',
  getParentRoute: () => rootRouteImport,
} as any)
const TriggersPersonaRoute = TriggersPersonaRouteImport.update({
  id: '/triggers/persona',
  path: '/triggers/persona',
  getParentRoute: () => rootRouteImport,
} as any)
const TriggersContentRoute = TriggersContentRouteImport.update({
  id: '/triggers/content',
  path: '/triggers/content',
  getParentRoute: () => rootRouteImport,
} as any)
const RunsWorkflowIdRoute = RunsWorkflowIdRouteImport.update({
  id: '/runs/$workflowId',
  path: '/runs/$workflowId',
  getParentRoute: () => rootRouteImport,
} as any)
const PersonasPersonaIdRoute = PersonasPersonaIdRouteImport.update({
  id: '/personas/$personaId',
  path: '/personas/$personaId',
  getParentRoute: () => rootRouteImport,
} as any)
const PerformanceContentIdRoute = PerformanceContentIdRouteImport.update({
  id: '/performance/$contentId',
  path: '/performance/$contentId',
  getParentRoute: () => rootRouteImport,
} as any)
const ContentContentIdRoute = ContentContentIdRouteImport.update({
  id: '/content/$contentId',
  path: '/content/$contentId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/edit': typeof EditRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/schedules': typeof SchedulesRoute
  '/signup': typeof SignupRoute
  '/content/$contentId': typeof ContentContentIdRoute
  '/performance/$contentId': typeof PerformanceContentIdRoute
  '/personas/$personaId': typeof PersonasPersonaIdRoute
  '/runs/$workflowId': typeof RunsWorkflowIdRoute
  '/triggers/content': typeof TriggersContentRoute
  '/triggers/persona': typeof TriggersPersonaRoute
  '/content/': typeof ContentIndexRoute
  '/performance/': typeof PerformanceIndexRoute
  '/personas/': typeof PersonasIndexRoute
  '/runs/': typeof RunsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/edit': typeof EditRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/schedules': typeof SchedulesRoute
  '/signup': typeof SignupRoute
  '/content/$contentId': typeof ContentContentIdRoute
  '/performance/$contentId': typeof PerformanceContentIdRoute
  '/personas/$personaId': typeof PersonasPersonaIdRoute
  '/runs/$workflowId': typeof RunsWorkflowIdRoute
  '/triggers/content': typeof TriggersContentRoute
  '/triggers/persona': typeof TriggersPersonaRoute
  '/content': typeof ContentIndexRoute
  '/performance': typeof PerformanceIndexRoute
  '/personas': typeof PersonasIndexRoute
  '/runs': typeof RunsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/edit': typeof EditRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/schedules': typeof SchedulesRoute
  '/signup': typeof SignupRoute
  '/content/$contentId': typeof ContentContentIdRoute
  '/performance/$contentId': typeof PerformanceContentIdRoute
  '/personas/$personaId': typeof PersonasPersonaIdRoute
  '/runs/$workflowId': typeof RunsWorkflowIdRoute
  '/triggers/content': typeof TriggersContentRoute
  '/triggers/persona': typeof TriggersPersonaRoute
  '/content/': typeof ContentIndexRoute
  '/performance/': typeof PerformanceIndexRoute
  '/personas/': typeof PersonasIndexRoute
  '/runs/': typeof RunsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/edit'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/schedules'
    | '/signup'
    | '/content/$contentId'
    | '/performance/$contentId'
    | '/personas/$personaId'
    | '/runs/$workflowId'
    | '/triggers/content'
    | '/triggers/persona'
    | '/content/'
    | '/performance/'
    | '/personas/'
    | '/runs/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/edit'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/schedules'
    | '/signup'
    | '/content/$contentId'
    | '/performance/$contentId'
    | '/personas/$personaId'
    | '/runs/$workflowId'
    | '/triggers/content'
    | '/triggers/persona'
    | '/content'
    | '/performance'
    | '/personas'
    | '/runs'
  id:
    | '__root__'
    | '/'
    | '/edit'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/schedules'
    | '/signup'
    | '/content/$contentId'
    | '/performance/$contentId'
    | '/personas/$personaId'
    | '/runs/$workflowId'
    | '/triggers/content'
    | '/triggers/persona'
    | '/content/'
    | '/performance/'
    | '/personas/'
    | '/runs/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  EditRoute: typeof EditRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SchedulesRoute: typeof SchedulesRoute
  SignupRoute: typeof SignupRoute
  ContentContentIdRoute: typeof ContentContentIdRoute
  PerformanceContentIdRoute: typeof PerformanceContentIdRoute
  PersonasPersonaIdRoute: typeof PersonasPersonaIdRoute
  RunsWorkflowIdRoute: typeof RunsWorkflowIdRoute
  TriggersContentRoute: typeof TriggersContentRoute
  TriggersPersonaRoute: typeof TriggersPersonaRoute
  ContentIndexRoute: typeof ContentIndexRoute
  PerformanceIndexRoute: typeof PerformanceIndexRoute
  PersonasIndexRoute: typeof PersonasIndexRoute
  RunsIndexRoute: typeof RunsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/schedules': {
      id: '/schedules'
      path: '/schedules'
      fullPath: '/schedules'
      preLoaderRoute: typeof SchedulesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/edit': {
      id: '/edit'
      path: '/edit'
      fullPath: '/edit'
      preLoaderRoute: typeof EditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/runs/': {
      id: '/runs/'
      path: '/runs'
      fullPath: '/runs/'
      preLoaderRoute: typeof RunsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/personas/': {
      id: '/personas/'
      path: '/personas'
      fullPath: '/personas/'
      preLoaderRoute: typeof PersonasIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/performance/': {
      id: '/performance/'
      path: '/performance'
      fullPath: '/performance/'
      preLoaderRoute: typeof PerformanceIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/content/': {
      id: '/content/'
      path: '/content'
      fullPath: '/content/'
      preLoaderRoute: typeof ContentIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/triggers/persona': {
      id: '/triggers/persona'
      path: '/triggers/persona'
      fullPath: '/triggers/persona'
      preLoaderRoute: typeof TriggersPersonaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/triggers/content': {
      id: '/triggers/content'
      path: '/triggers/content'
      fullPath: '/triggers/content'
      preLoaderRoute: typeof TriggersContentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/runs/$workflowId': {
      id: '/runs/$workflowId'
      path: '/runs/$workflowId'
      fullPath: '/runs/$workflowId'
      preLoaderRoute: typeof RunsWorkflowIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/personas/$personaId': {
      id: '/personas/$personaId'
      path: '/personas/$personaId'
      fullPath: '/personas/$personaId'
      preLoaderRoute: typeof PersonasPersonaIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/performance/$contentId': {
      id: '/performance/$contentId'
      path: '/performance/$contentId'
      fullPath: '/performance/$contentId'
      preLoaderRoute: typeof PerformanceContentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/content/$contentId': {
      id: '/content/$contentId'
      path: '/content/$contentId'
      fullPath: '/content/$contentId'
      preLoaderRoute: typeof ContentContentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  EditRoute: EditRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SchedulesRoute: SchedulesRoute,
  SignupRoute: SignupRoute,
  ContentContentIdRoute: ContentContentIdRoute,
  PerformanceContentIdRoute: PerformanceContentIdRoute,
  PersonasPersonaIdRoute: PersonasPersonaIdRoute,
  RunsWorkflowIdRoute: RunsWorkflowIdRoute,
  TriggersContentRoute: TriggersContentRoute,
  TriggersPersonaRoute: TriggersPersonaRoute,
  ContentIndexRoute: ContentIndexRoute,
  PerformanceIndexRoute: PerformanceIndexRoute,
  PersonasIndexRoute: PersonasIndexRoute,
  RunsIndexRoute: RunsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
